export const ROUTES = {
  LOGIN: "/login",
  TOKEN_VERIFICATION: "/tokenverification/*",

  PORTAL_REDIRECTION: "/portal-redirection",

  DASHBOARD: "/dashboard",
  COMPANY_MANAGEMENT: "/company-management",
  SERVICE_MANAGEMENT: "/service-management",
  PRODUCT_MANAGEMENT: "/product-management",
  USER_GROUP: "/user-group",
  USER_GROUP_ADD: "/user-group/add",
  USER_GROUP_EDIT: "/user-group/edit/:id",
  USERS: "/users",
};
